module.exports = __webpack_public_path__ + "static/media/sigil-thumb-3-baratheon.1b38483a.png";